import { render } from "./DateTimeOrDurationForm.vue?vue&type=template&id=9521530c&scoped=true"
import script from "./DateTimeOrDurationForm.vue?vue&type=script&lang=js"
export * from "./DateTimeOrDurationForm.vue?vue&type=script&lang=js"

import "./DateTimeOrDurationForm.vue?vue&type=style&index=0&id=9521530c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9521530c"]])

export default __exports__